/**
 * The enumeration defines possible return type for a PowerShell script.
 */
export enum PowerShellReturnType {
  /**
   * The script does not return any value
   */
  None,

  /**
   * The script returns a single value
   */
  Explicit,

  /**
   * The script returns a hash table
   */
  Table,
}
